import { render, staticRenderFns } from "./AddressCheckout.vue?vue&type=template&id=55e64769&"
import script from "./AddressCheckout.vue?vue&type=script&lang=js&"
export * from "./AddressCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports